import React from 'react';

const MekanikFisikaGameScratch: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Saat memainkan game bergenre <i>platformer</i> atau aksi petualangan, pergerakan karakter yang terasa mulus dan responsif merupakan kunci utama kenyamanan pemain. Di platform pemrograman visual <b>Scratch</b>, menghadirkan simulasi hukum fisika seperti gravitasi, gaya gesek, dan pantulan tidak sesulit yang dibayangkan.
      </p>

      <p className="mb-4">
        Dengan memanfaatkan variabel dinamis seperti <code>y_velocity</code> (kecepatan vertikal) dan <code>x_velocity</code> (kecepatan horizontal), siswa dapat memprogram lompatan karakter yang realistis tanpa harus mengandalkan perintah loncat kaku yang tidak alami.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Memprogram Gravitasi dan Lompatan yang Mulus
      </h2>
      <ol className="list-decimal pl-6 mb-6 space-y-3">
        <li>
          <strong>Variabel Gravitasi:</strong> Buat perulangan selamanya (<code>forever loop</code>) yang secara konstan mengurangi nilai <code>y_velocity</code> sebesar nilai gravitasi konstan (misalnya -1), lalu ubah posisi Y karakter sesuai nilai <code>y_velocity</code>.
        </li>
        <li>
          <strong>Memicu Lompatan:</strong> Ketika tombol spasi ditekan dan karakter menyentuh lantai (<i>touching platform</i>), atur nilai <code>y_velocity</code> ke nilai positif tinggi (misalnya +12).
        </li>
        <li>
          <strong>Deteksi Tanah (Ground Collision):</strong> Jika karakter mendeteksi tabrakan dengan tanah (<i>touching color/ground</i>), reset <code>y_velocity</code> menjadi 0 dan naikkan sedikit posisi Y agar karakter tidak terperosok ke dalam lantai.
        </li>
      </ol>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Menambahkan Gaya Gesek (Inersia)
      </h2>
      <p className="mb-4">
        Untuk memberikan efek akselerasi halus saat karakter mulai berlari dan berhenti perlahan saat tombol dilepas, kalikan variabel <code>x_velocity</code> dengan angka desimal pengali seperti 0.85 di setiap akhir siklus perulangan. Efek inersia ini membuat karakter terasa memiliki bobot dan massa yang meyakinkan.
      </p>

      <p className="mb-4">
        Melalui simulasi fisika interaktif ini, anak-anak tidak hanya belajar logika koding, tetapi juga memahami konsep sains dan matematika secara visual dan menyenangkan.
      </p>
    </div>
  );
};

export default MekanikFisikaGameScratch;
